export default function handleLoginAuth(token: string) {
  window.localStorage.setItem('onyo-token', `Bearer ${token}`);
}
